/**
 *
 * Plan Selection Modal
 *
 */
import React from 'react';
import {
  ContentWrapper,
  Text,
} from './styledComponents';
import { Link } from 'react-router-dom';
import Button from 'components/Button';
import Modal from 'components/Modal';
import H1 from 'components/H1';

const IntuitiveModal = ({ modalProps, close }) => {
  return(
  <Modal shakeOnOpen close={close} title='Upgrade your plan'>
    <ContentWrapper>
      <H1>
        Ready to Upgrade?
      </H1>
      <Text>
        You've already created the maximum number of channels on your LITE plan.
        You can create another new channel when your plan renews in {modalProps.remainingDays} days, 
        or upgrade to the UNLIMITED plan.
      </Text>
      <Link to={{pathname: '/memento-plan', discount: 'le'}}>
      <Button onClick={close}>Upgrade TO Unlimited</Button>
      </Link>
    </ContentWrapper>
  </Modal>
);}

export default IntuitiveModal;



// WEBPACK FOOTER //
// ./src/components/IntuitiveModal/index.js